import { ProductsById } from "../modules/products";

export const ProductsByIdPage = () => {
  return <ProductsById />;
};
